import React, { PropsWithChildren, useContext } from "react";
import styled from "@emotion/styled";
import { useEditor } from "@craftjs/core";
import { Header } from "./Header";
import { IBuilderContext, BuilderContext } from "../../providers";

const CenterPanelStyled = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  padding-top: 2px;
  background: var(--builder-panel-group-background);
  border: 1px solid var(--builder-panel-border-outer);
`;

const MainConvasStyled = styled.div`
  position: relative;
  overflow: auto;
  padding: 20px;
  flex-grow: 1;
  max-height: 100%;
  background: var(--builder-canvas-background);
  color: #333;
`;

const InnerCanvasStyled = styled.div<any>`
  height: ${(props) => `${props.viewport?.height}px`};
  width: ${(props) => `${props.viewport?.width}px`};
  margin: 0 auto;
  overflow: auto;
`;

export const CenterPanel: React.FC<PropsWithChildren> = ({ children }) => {
  const { connectors } = useEditor();
  const { viewport } = useContext<IBuilderContext>(BuilderContext);

  return (
    <CenterPanelStyled>
      <Header />
      <MainConvasStyled className="main-canvas">
        <InnerCanvasStyled
          viewport={viewport}
          ref={(ref: any) => connectors.select(connectors.hover(ref, ""), "")}
        >
          {children}
        </InnerCanvasStyled>
      </MainConvasStyled>
    </CenterPanelStyled>
  );
};
